// extracted by mini-css-extract-plugin
export var assigneeBadge = "_k9-0";
export var assigneeDetails = "_k9-1";
export var assigneeInfo = "_k9-2";
export var dropdownContainer = "_k9-4";
export var dropdownImage = "_k9-5";
export var editAssigneeInfo = "_k9-3";
export var editAssigneeModalContainer = "_k9-6";
export var hidden = "_k9-8";
export var input = "_k9-7";